import React from 'react';

import { forwardRef, Progress as ChakraProgress } from '@chakra-ui/react';

import { ProgressProps } from './types';

export const Progress = forwardRef<ProgressProps, 'div'>(
  (props: ProgressProps, ref) => {
    return <ChakraProgress ref={ref} {...props} />;
  }
);
